export const FETCH_BANKS = "FETCH_BANKS";
export const LOAD_BANK_LIST = "LOAD_BANK_LIST";
export const SET_REDIRECT = "SET_REDIRECT";
export const SET_ZWALLET_TRANSFER = "SET_ZWALLET_TRANSFER";


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/types.js